import React from 'react';
import { ConnectedConfiguratorScreen } from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/Screen';
import BaseOptionsListContainer from '@configuratorware/configurator-frontendgui/App/Modules/Creator/Containers/OptionsList';
import BaseProductPartsListContainer from '@configuratorware/configurator-frontendgui/App/Modules/Creator/Containers/ProductPartsList';
import Option from '../Components/Option/Option';
import CustomThemeProvider from '../Custom/ThemeProvider';

const OptionsListContainer = (props) => <BaseOptionsListContainer {...props} OptionComponent={Option} />;
const ConfiguratorScreen = (props) => (
  <ConnectedConfiguratorScreen
    {...props}
    OptionsListContainer={OptionsListContainer}
    ThemeProvider={CustomThemeProvider}
    renderProductParts={(dispatchAction, onOptionClassificationSelect, selectOptionClassification) => (
      <>
        <BaseProductPartsListContainer
          onSelect={(optionClassification) =>
            onOptionClassificationSelect(dispatchAction, optionClassification, selectOptionClassification)
          }
          onCloseSelectedPart={() => null}
        />
      </>
    )}
  />
);

export default ConfiguratorScreen;
